import React from 'react';
import { get, map, isNil, filter, size, find, noop, forEach, isUndefined, isEmpty, keys, head } from 'lodash';
import classnames from 'classnames';
import searchQuery from 'query-string';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { getDisplayValue } from 'resolvers/formatValue';
import { DATA_TYPES } from 'constants/common';
import { BLANK_VALUE_SYMBOL } from 'constants/common';
import { Icon } from 'modules/icon-bank';

import { radioBox as RadioBox } from 'ui/views/generic/radioBox';
import { checkbox as Checkbox } from 'ui/views/generic/checkbox';
import { button as Button } from 'modules/button';
import { costCalculation as CostCalculation, costCalculationPreloader as CostCalculationPreloader } from 'ui/views/widgets/costCalculation';
import { DASHBOARD_SUB_ROUTES } from 'constants/route-paths';

/************************************** */

// days supply for each drug
const DaysOfSupply = ( props ) => {

    const readonly = get( props, 'readonly', false );

    return (
        <div className='ui-days-of-supply'>
            { map( props.items, item => {

                //  get the calss name for days supply cell
                const className = classnames( 'ui-days-of-supply__item', {
                        'ui-days-of-supply__item--selected': item.selected,
                        'ui-days-of-supply__item--readonly': props.readonly
                    }
                );

                return (
                    <div className={ className } key={ item.days } onClick={ () => ! readonly ? props.onActionClick( { type: 'daysSupplySelection', item: item, rx: props.prescription, drug: props.drug } ): noop }>
                        { item.days }
                    </div>
                );
            } ) }
        </div>
    );
};

const checkIfCanMoveForward = ( selectedRx ) => {

    if( isEmpty( selectedRx ) ) {
        return false;
    }
    
    let canMoveForward = true;

    if( 0 !== size( selectedRx ) ) {
        forEach( selectedRx, rx => {

            // get the selected drug
            const selectedDrug = find( rx.drugs, { selected: true } );
            if( isUndefined( selectedDrug ) ) {
                canMoveForward = false;
            } else {

                // get the selected drug of supply
                const selectedDaysOfSupply = find( selectedDrug.daysOfSupply, { selected: true } );
                if( isUndefined( selectedDaysOfSupply ) ) {
                    canMoveForward = false;
                }
            }

        } );
    }

    return canMoveForward;
};

/********************************** */

const _checkoutPrescriptionInfo = ( props ) => {
    
    const { widgetConfig, rxItemConfig, prescriptions, memberId } = props;

    // widget title and subtitle info
    const { title, subtitle } = widgetConfig;

    // title and error message info
    const { fieldTitles, drugTypeTitles, errorMessages } = rxItemConfig;

    // get the list of selected rx
    const selectedRx = filter( prescriptions, rx => {
        return rx.selected;
    } );

    // check if user can move forward to the next step
    const canMoveForward = checkIfCanMoveForward( selectedRx );
    const newOrderEstimatedCost = props.visibility.newOrderEstimatedCost
    
    

    return (
        <div className='ui-prescription-info'>

            {/* header view */}
            <div className='ui-prescription-info__header'>
                <div className='ui-prescription-info__header__title'>
                    { getLabel( title ) }
                </div>
                <div className='ui-prescription-info__header__subtitle'>
                    { getLabel( subtitle ) }
                </div>
            </div>

            {/* body view */}
            <div className='ui-prescription-info__body'>

                { map( prescriptions, prescription => {

                     // check to show Drug Selection
                    const showDrugSelection = 1 < size( get( prescription, 'drugs', [] ) ) ? true: false;
                    let rxErrorFlagMessage = null;

                    if( ! isEmpty( prescription.flags ) ) {

                        const flagKeyList = filter( keys( prescription.flags ), key => {
                            return true === prescription.flags[ key ];
                        } );

                        if( 0 !== size( flagKeyList ) ) {
                            const flagKey = head( flagKeyList );
                            rxErrorFlagMessage = get( errorMessages, `${flagKey}`, {} );
                        }
                    }

                    const isRxReadOnly = get( prescription, 'readonly', false );
                    log.debug( prescription );

                    const className = classnames( 'ui-prescription-info__body__list', {
                            'ui-prescription-info__body__list--readonly': true === prescription.readonly,
                        }
                    );

                    return (
                        <div key={ prescription.id } className= { className }>

                             {/* expired or zero refills flag */}
                            { ! isNil( rxErrorFlagMessage ) && (
                                <div className='ui-prescription-info__body__list__flag-error'>
                                     <div className='ui-prescription-info__body__list__flag-error__title'>
                                        <Icon id={ 'flagError' } />

                                         { getLabel( rxErrorFlagMessage ) }
                                    </div>
                                </div>
                            ) }

                            {/* get the prescription number */}
                            <div className='ui-prescription-info__body__list__rx'
                            >
                                <div className='ui-prescription-info__body__list__rx__title'>{ getLabel( fieldTitles.rxNumber ) } </div>
                                <div className='ui-prescription-info__body__list__rx__value ui-prescription-info__body__list__rx__value--action'
                                onClick={ () => props.history.push( {
                                    pathname: DASHBOARD_SUB_ROUTES.PRESCRIPTION_DETAIL,
                                    search: searchQuery.stringify( {
                                        rxId: prescription.id
                                    } ),
                                    state: { memberId: memberId }
                                } ) }
                                >{ get( prescription, 'rxNumber', BLANK_VALUE_SYMBOL ) } </div>
                            </div>

                            {/* selected drug section */}
                            <div className='ui-prescription-info__body__list__drugs'>

                                { map( get( prescription, 'drugs', [] ), drug => {

                                    // get daysOfSupply lists
                                    const selectedDaysOfSupply =  find( drug.daysOfSupply, { selected: true } );

                                    // get the estimated value fo drug
                                    const estimatedCost = selectedDaysOfSupply ? getDisplayValue( { type: DATA_TYPES.CURRENCY, value: selectedDaysOfSupply.value } ): BLANK_VALUE_SYMBOL;

                                    // get the selected quantity
                                    const quantity = isUndefined( selectedDaysOfSupply ) ? BLANK_VALUE_SYMBOL: selectedDaysOfSupply[ 'quantity' ];
                 
                                    // check if drug selection is allowed
                                    const readonly = get( drug, 'readonly', false );

                                    // check if branded
                                    const isBranded = get( drug, 'flags.branded', false );
                                    const drugType = isBranded ? 'branded': 'generic';

                                    const flagClass = classnames( 'ui-prescription-info__body__list__drugs__drug__drugName__title__flag',
                                        `ui-prescription-info__body__list__drugs__drug__drugName__title__flag--${drugType}`
                                    );

                                    const drugNameClass = classnames( 'ui-prescription-info__body__list__drugs__drug__drugName__value', {
                                        'ui-prescription-info__body__list__drugs__drug__drugName__value--action': ! readonly
                                    } );

                                    return (
                                        <div className='ui-prescription-info__body__list__drugs__drug' key={ drug.id }>

                                            {/*  drug name */}
                                            <div className='ui-prescription-info__body__list__drugs__drug__drugName'>
                                                <div className='ui-prescription-info__body__list__drugs__drug__drugName__title'>
                                                    { ( ! isBranded && 1 < size( get( prescription, 'drugs', [] ) ) ) ? getLabel( fieldTitles.alternateDrug ):  getLabel( fieldTitles.drugName )  }

                                                    {/* branded / genric flag */}
                                                    <span className={ flagClass }>{ getLabel( drugTypeTitles[ `${drugType}` ] ) }</span>
                                                </div>
                                                <div className={ drugNameClass }
                                                    onClick={ () => ! readonly ? props.onActionClick( { type: 'drugSelection', rx: prescription, drug } ): noop }
                                                >

                                                    { showDrugSelection && (
                                                        <RadioBox
                                                            key={ drug.name }
                                                            size='xs'
                                                            value={ drug.name }
                                                            selected={ drug.selected }
                                                            id={ drug.id }
                                                            className= { readonly ? 'ui-prescription-info__body__list__drugs__drug__drugName__value--readonly': null }
                                                        />
                                                    ) }
                                                    
                                                    { drug.name }
                                                </div>
                                            </div>
                                            
                                            {/* estimated cost based on the no of days supply selected */}
                                         {newOrderEstimatedCost && <div className='ui-prescription-info__body__list__drugs__drug__estimated-cost'>
                                                <div className='ui-prescription-info__body__list__drugs__drug__estimated-cost__title'>
                                                    { getLabel( fieldTitles.estimatedCost )}
                                                </div>
                                                <div className='ui-prescription-info__body__list__drugs__drug__estimated-cost__value'>
                                                    { estimatedCost }
                                                </div>
                                            </div>}

                                            {/* days supply selection */}
                                            <div className='ui-prescription-info__body__list__drugs__drug__daysofsupply'>
                                                <div className='ui-prescription-info__body__list__drugs__drug__daysofsupply__title'>
                                                    { getLabel( fieldTitles.daysOfSupply ) }
                                                </div>
                                                <DaysOfSupply
                                                    items={ drug.daysOfSupply }
                                                    onActionClick={ props.onActionClick }
                                                    readonly={ readonly || ! drug.selected }
                                                    drug={ drug }
                                                    prescription={ prescription }
                                                />
                                            </div>

                                            {/* quantity */}
                                            <div className='ui-prescription-info__body__list__drugs__drug__quantity'>
                                                <div className='ui-prescription-info__body__list__quantity__title'>{ getLabel( fieldTitles.quantity ) } </div>
                                                <div className='ui-prescription-info__body__list__quantity__value'>{ quantity } </div>
                                            </div>
                                            
                                        </div>
                                       
                                    );
                                } ) }
                            </div>

                            {/* drug quantity */}
                            {/* <div className='ui-prescription-info__body__list__quantity'>
                                <div className='ui-prescription-info__body__list__quantity__title'>{ getLabel( fieldTitles.quantity ) } </div>
                                <div className='ui-prescription-info__body__list__quantity__value'>{ get( prescription, 'quantity', BLANK_VALUE_SYMBOL ) } </div>
                            </div> */}

                            {/* drug quantity */}
                             <div className='ui-prescription-info__body__list__selection'>
                                <Checkbox
                                    size='xl'
                                    value={ prescription.selected }
                                    disabled={ isRxReadOnly }
                                    onClick={ () => isRxReadOnly ? noop: props.onActionClick( { type: 'rxSelection', rx: prescription } ) }
                                />
                            </div>
                            
                        </div>
                    );
                } ) }

            {props.visibility.newOrderCostCalculation && <CostCalculation
                fields = { get( props, 'costCalculationConfig', {} ) }
                values={ get( props, 'costCalculation', {} ) }
                flags={ get( props, 'flags', {} )}
                visibility = {props.visibility}
            />}

            </div>

            {/* footer */}
            <div className='ui-prescription-info__footer'>
                {
                    map( props.navActions, action => {
                        return(
                            <Button
                                key={ action.name }
                                title={ action.title }
                                size='large'
                                outline={ 'cancel' === action.name ? true: false }
                                className='ui-prescription-info__footer__action'
                                showPostIcon={ 'cancel' !== action.name ? true: false }
                                postIconId={ 'arrow' }
                                disabled={ ( 'cancel' !== action.name && ! canMoveForward ) ? true: false }
                                iconWidth={ 18 }
                                iconHeight={ 18 }
                                onClick={ () => props.onActionClick( { type: 'navAction', value: action } ) }
                            />
                        );
                    } )
                }

            </div>
            
        </div>
    );
};

// set display name
_checkoutPrescriptionInfo.displayName = 'prescriptionInfo';

// set default props
_checkoutPrescriptionInfo.defaultProps = {};

// prop types
_checkoutPrescriptionInfo.propTypes = {};

/*************************************** */

export const prescriptionInfoPreloader = ( ) => {
    return (
        <div className='ui-prescription-info-preloader'>
           <div className='ui-prescription-info-preloader__title'></div>
           <div className='ui-prescription-info-preloader__subtitle'></div>
           <div className='ui-prescription-info-preloader__flag-error'></div>

           <div className='ui-prescription-info-preloader__details'>
                <div className='ui-prescription-info-preloader__detail'>
                    <div className='ui-prescription-info-preloader__detail__title'></div>
                    <div className='ui-prescription-info-preloader__detail__value'></div>
                </div>
                { map( [ ...Array( 2 ).keys() ], item => {
                    return (
                        <div key={ item } className='ui-prescription-info-preloader__block'>
                            <div className='ui-prescription-info-preloader__block__section'>
                                <div className='ui-prescription-info-preloader__block__section__title'></div>
                                <div className='ui-prescription-info-preloader__block__section__value'></div>
                            </div>
                            <div className='ui-prescription-info-preloader__block__section'>
                                <div className='ui-prescription-info-preloader__block__section__title'></div>
                                <div className='ui-prescription-info-preloader__block__section__value'></div>
                            </div>
                        </div>
                    );
                } ) }
                <div className='ui-prescription-info-preloader__detail'>
                    <div className='ui-prescription-info-preloader__detail__title'></div>
                    <div  className='ui-prescription-info-preloader__detail__square'>
                    { map( [ ...Array( 3 ).keys() ], item => {
                        return (
                            <div key={ item } className='ui-prescription-info-preloader__detail__square__view'></div>
                        );
                    } ) }
                     </div>
                </div>
                <div className='ui-prescription-info-preloader__detail'>
                    <div className='ui-prescription-info-preloader__detail__title'></div>
                    <div className='ui-prescription-info-preloader__detail__value'></div>
                </div>
                <div className='ui-prescription-info-preloader__detail'>
                    <div className='ui-prescription-info-preloader__detail__checkbox'></div>
                </div>
           </div>
           <CostCalculationPreloader />

           <div className='ui-prescription-info-preloader__actions'>
            { map( [ ...Array( 2 ).keys() ], item => {
                    return (
                        <div key={ item } className='ui-prescription-info-preloader__actions__action'></div>
                    );
                } ) }
           </div>
        </div>
    );
};

// set display name
prescriptionInfoPreloader.displayName = 'prescriptionInfoPreloader';

// set default props
prescriptionInfoPreloader.defaultProps = {};

// prop types
prescriptionInfoPreloader.propTypes = {};


/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { checkoutPrescriptionInfo as CheckoutPrescriptionInfo } from 'ui/views/widgets/checkoutPrescriptionInfo';
 *
 * // render
 * <PrescriptionInfo propName='propValue'/>
 */
export const checkoutPrescriptionInfo = withNetworkState( prescriptionInfoPreloader, _checkoutPrescriptionInfo );
